import API from "./api";
import { CHECK_IN, CHECK_OUT, LOGIN } from "./endpoint";

// CHECK IN
export const checkInAPI = (data) =>
  API.post(CHECK_IN, data);

// CHECK OUT
export const checkOutAPI = () =>
  API.post(CHECK_OUT);

export const dashboardSummaryAPI = () =>
  API.get("/attendance/dashboard-summary");
// ADMIN OVERALL ATTENDANCE
export const adminOverallReportAPI = (params) => {
  return API.get("/attendance/admin-overall-report", { params });
};

export const employeeLoginHistoryAPI = (id, params) => {
  return API.get(`/attendance/employee-login-history/${id}`, { params });
};